import { getStore } from "../stores/base.js";
import { LISTENER_CMDS } from "./constants.js";
import { errorMsg, isMobile, msgData } from "./utils.js";

export function boardHandler(data, workerInstance) {
  switch (data.command) {
    case LISTENER_CMDS.BOARD_OPEN_FORM:
      return openForm(data, workerInstance.pageId);

    case LISTENER_CMDS.BOARD_IMPORT_CSV:
      return importCSV(data, workerInstance);

    default:
      return false;
  }
}

async function importCSV(data, workerInstance) {
  if (isMobile()) {
    let message =
      "Web app exclusive! Import CSV is only available on our web app.";
    import("widgets/feedback").then(({ Toast }) => {
      Toast.showError({
        message
      });
    });
    return errorMsg(data, {
      message
    });
  }
  const usePageRuntimeStore = getStore(`runtime_page_${workerInstance.pageId}`);
  if (usePageRuntimeStore) {
    usePageRuntimeStore.getState().renderPortal({
      id: `${data.flowId}/importCSV`,
      path: "case/import_csv",
      componentProps: {
        ...data,
        onDone: () => {
          workerInstance.postMessage(msgData(data, { message: "imported" }));
        },
        onError: (errorInfo) => {
          console.info("Failed to import through SDK : ", errorInfo);
          workerInstance.postMessage(
            errorMsg(data, {
              message: "Error while importing",
              errorInfo
            })
          );
        },
        onCancel: () => {
          workerInstance.postMessage(
            msgData(data, {
              isAborted: true,
              message: "import aborted"
            })
          );
        }
      }
    });
    return;
  }
}

async function openForm(data, pageId) {
  const usePageRuntimeStore = getStore(`runtime_page_${pageId}`);
  if (usePageRuntimeStore) {
    usePageRuntimeStore.getState().renderPortal({
      id: `${data.flowId}/openForm`,
      path: `case/openform`,
      componentProps: {
        ...data,
        onDone: () => {},
        onCancel: () => {}
      }
    });
    return;
  }
}
